export const journeyStatusUpdate = (data) => {
  return {
    type: "JOURNEYSTATUSUPDATE",
    data: data,
  };
};
